import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { classifyHttpError } from '../errors/classify-http-error.util';
import { attachNormalizedHttpError } from '../errors/http-error.model';

/**
 * Normalizes and classifies every failed request, then re-throws the same instance.
 * It must never swallow: `LariErrorHandler` is the backstop for whatever nobody caught.
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        attachNormalizedHttpError(error, classifyHttpError(req, error));
      }
      return throwError(() => error);
    }),
  );
